module.exports = __webpack_public_path__ + "img/sarit_logo.acd73ab4.png";